const classnames = (...classnamesList: any): string => {
	const result = new Set();

	classnamesList.forEach((item) => {
		const type = typeof item;

		if (type === 'string' && item.length > 0) {
			result.add(item);
		} else if (type === 'object' && item !== null) {
			Object.entries(item).forEach(([key, value]) => {
				if (value) {
					result.add(key);
				}
			});
		}
	});

	return Array.from(result).join(' ');
};

export default classnames;
